/* =============================================================================
   PRO ART — Hauteur reelle de l'en-tete, publiee en variable CSS

   L'en-tete est en position: fixed, il ne pousse donc rien. Chaque section de
   haut de page doit reserver sa hauteur elle-meme. Jusqu'ici c'etait fait a la
   main, avec des valeurs en dur (160px un peu partout, 0 sur le catalogue).

   Deux raisons pour lesquelles une valeur en dur ne tient pas :
   - la hauteur du logo est pilotee par le reglage marchand « Largeur du logo »
     (height: auto, max-height: 112px). Elle change le jour ou Yan change son
     logo, et toutes les pages passeraient sous l'en-tete d'un coup ;
   - elle varie selon le palier responsive.

   On mesure donc pour de vrai et on publie --proart-header-offset. Le CSS a un
   repli par palier si ce fichier ne s'execute pas : le contenu sera un peu bas,
   jamais cache.
   ============================================================================= */
(function () {
  var root = document.documentElement;
  var frame = null;

  function measure() {
    frame = null;

    var announce = document.querySelector('.proart-announce');
    var header = document.querySelector('.proart-header');
    if (!header) return;

    /* La barre d'annonce est desactivable dans l'editeur. Quand elle disparait,
       l'en-tete doit remonter a top: 0 — sinon il flotte 36px plus bas, laisse
       un trou transparent, et tout le contenu de haut de page repasse dessous.
       Les deux variables sortent donc de la meme mesure, elles ne peuvent pas
       se contredire. */
    var announceHeight = announce ? announce.offsetHeight : 0;
    root.style.setProperty('--proart-announce-height', announceHeight + 'px');

    /* offsetHeight ignore les transformations : la valeur reste juste meme
       quand l'en-tete est masque au defilement (translateY(-110%)) ou remonte
       a top: 0 en etat « scrolled ». On mesure une hauteur, pas une position. */
    var offset = announceHeight + header.offsetHeight;
    if (offset > 0) root.style.setProperty('--proart-header-offset', offset + 'px');
  }

  /* Une seule mesure par frame, sinon le resize en declenche des dizaines. */
  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(measure);
  }

  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);

  /* Le logo est une image : sa hauteur n'est connue qu'une fois chargee. Sans
     ce rappel, la premiere mesure se fait sur un en-tete encore plat. */
  window.addEventListener('load', schedule);
  document.addEventListener('DOMContentLoaded', function () {
    var logo = document.querySelector('.proart-header__logo-img');
    if (logo && !logo.complete) logo.addEventListener('load', schedule);
  });

  /* Filet pour tout ce qui redimensionne l'en-tete sans passer par un resize :
     police qui arrive en retard, menu deroulant, edition dans l'editeur. */
  if (typeof ResizeObserver !== 'undefined') {
    document.addEventListener('DOMContentLoaded', function () {
      var header = document.querySelector('.proart-header');
      if (header) new ResizeObserver(schedule).observe(header);
    });
  }
})();
